import Axios, { AxiosInstance } from 'axios';
import { useAuth } from '../hooks/useAuth';
import { useAppConfigContext } from '../../config/hooks/useAppConfig';
import { getPublicApiUrl } from '../../config/publicEnv';

export const useAuthenticatedAxios = () => {
  const { accessToken, logout } = useAuth();
  const { config } = useAppConfigContext();

  const getAxios = async (): Promise<AxiosInstance> => {
    const axios = Axios.create({
      baseURL: getPublicApiUrl() || config.API_URL,
    });

    axios.interceptors.request.use(async (requestConfig) => {
      requestConfig.headers.Authorization = accessToken
        ? `Bearer ${accessToken}`
        : undefined;
      return requestConfig;
    });

    axios.interceptors.response.use(
      (response) => response,
      (err) => {
        if (err.response?.status === 401) {
          logout();
        }
        return Promise.reject(err);
      }
    );

    return axios;
  };

  return getAxios;
};
